"use strict"; // This exists to allow the library users to do something like this: import Unit from 'corona';

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* support */

var uuid_1 = require("./support/uuid");

Object.defineProperty(exports, "UUID", {
  enumerable: true,
  get: function get() {
    return uuid_1.UUID;
  }
});
Object.defineProperty(exports, "EmptyUUID", {
  enumerable: true,
  get: function get() {
    return uuid_1.EmptyUUID;
  }
});

var numeric_1 = require("./support/numeric");

Object.defineProperty(exports, "convert", {
  enumerable: true,
  get: function get() {
    return numeric_1.convert;
  }
});

__exportStar(require("./prompt_login"), exports);

__exportStar(require("./port_index"), exports);

var port_logical_sort_1 = require("./port_logical_sort");

Object.defineProperty(exports, "logicalOrder", {
  enumerable: true,
  get: function get() {
    return port_logical_sort_1.logicalOrder;
  }
});

var filter_1 = require("./filter");

Object.defineProperty(exports, "filter", {
  enumerable: true,
  get: function get() {
    return filter_1.filter;
  }
});

var storage_1 = require("./storage/storage");

Object.defineProperty(exports, "clear", {
  enumerable: true,
  get: function get() {
    return storage_1.clear;
  }
});

__exportStar(require("./unit_field"), exports);

var credentials_1 = require("./credentials");

Object.defineProperty(exports, "Credentials", {
  enumerable: true,
  get: function get() {
    return credentials_1.Credentials;
  }
});
Object.defineProperty(exports, "decodeCredentials", {
  enumerable: true,
  get: function get() {
    return credentials_1.decodeCredentials;
  }
});
/* api enums/structs */

__exportStar(require("./field"), exports);
/* api-classes */


__exportStar(require("./units"), exports);

var unit_1 = require("./unit");

Object.defineProperty(exports, "Unit", {
  enumerable: true,
  get: function get() {
    return unit_1.Unit;
  }
});
Object.defineProperty(exports, "decodeUnit", {
  enumerable: true,
  get: function get() {
    return unit_1.decodeUnit;
  }
});
Object.defineProperty(exports, "DeviceType", {
  enumerable: true,
  get: function get() {
    return unit_1.DeviceType;
  }
});
Object.defineProperty(exports, "ProductType", {
  enumerable: true,
  get: function get() {
    return unit_1.ProductType;
  }
});

var health_1 = require("./health");

Object.defineProperty(exports, "HealthStatusEnum", {
  enumerable: true,
  get: function get() {
    return health_1.HealthStatusEnum;
  }
});

var configuration_1 = require("./configuration");

Object.defineProperty(exports, "Configuration", {
  enumerable: true,
  get: function get() {
    return configuration_1.Configuration;
  }
});
Object.defineProperty(exports, "ConfigurationType", {
  enumerable: true,
  get: function get() {
    return configuration_1.ConfigurationType;
  }
});
Object.defineProperty(exports, "ConfigurationTypeToString", {
  enumerable: true,
  get: function get() {
    return configuration_1.ConfigurationTypeToString;
  }
});

var data_1 = require("./data");

Object.defineProperty(exports, "Data", {
  enumerable: true,
  get: function get() {
    return data_1.Data;
  }
});

var expression_1 = require("./expression");

Object.defineProperty(exports, "parseExpression", {
  enumerable: true,
  get: function get() {
    return expression_1.parseExpression;
  }
});

var port_1 = require("./port");

Object.defineProperty(exports, "decodePort", {
  enumerable: true,
  get: function get() {
    return port_1.decodePort;
  }
});
Object.defineProperty(exports, "Port", {
  enumerable: true,
  get: function get() {
    return port_1.Port;
  }
});
Object.defineProperty(exports, "HistoryAggregate", {
  enumerable: true,
  get: function get() {
    return port_1.HistoryAggregate;
  }
});

var ports_1 = require("./ports");

Object.defineProperty(exports, "groupPortsByObjectResource", {
  enumerable: true,
  get: function get() {
    return ports_1.groupPortsByObjectResource;
  }
});
Object.defineProperty(exports, "sortPorts", {
  enumerable: true,
  get: function get() {
    return ports_1.sortPorts;
  }
});

var workorder_1 = require("./workorder");

Object.defineProperty(exports, "WorkOrder", {
  enumerable: true,
  get: function get() {
    return workorder_1.WorkOrder;
  }
});
Object.defineProperty(exports, "decodeWorkOrders", {
  enumerable: true,
  get: function get() {
    return workorder_1.decodeWorkOrders;
  }
});
Object.defineProperty(exports, "decodeWorkOrder", {
  enumerable: true,
  get: function get() {
    return workorder_1.decodeWorkOrder;
  }
});
Object.defineProperty(exports, "WorkSystem", {
  enumerable: true,
  get: function get() {
    return workorder_1.WorkSystem;
  }
});
Object.defineProperty(exports, "WorkType", {
  enumerable: true,
  get: function get() {
    return workorder_1.WorkType;
  }
});
Object.defineProperty(exports, "WorkUrgency", {
  enumerable: true,
  get: function get() {
    return workorder_1.WorkUrgency;
  }
});
Object.defineProperty(exports, "WorkState", {
  enumerable: true,
  get: function get() {
    return workorder_1.WorkState;
  }
});
Object.defineProperty(exports, "workTypeToString", {
  enumerable: true,
  get: function get() {
    return workorder_1.workTypeToString;
  }
});
Object.defineProperty(exports, "workStateToString", {
  enumerable: true,
  get: function get() {
    return workorder_1.workStateToString;
  }
});
Object.defineProperty(exports, "workSystemToString", {
  enumerable: true,
  get: function get() {
    return workorder_1.workSystemToString;
  }
});
Object.defineProperty(exports, "WorkCategory", {
  enumerable: true,
  get: function get() {
    return workorder_1.WorkCategory;
  }
});
Object.defineProperty(exports, "workCategoryToString", {
  enumerable: true,
  get: function get() {
    return workorder_1.workCategoryToString;
  }
});
Object.defineProperty(exports, "stringToWorkCategory", {
  enumerable: true,
  get: function get() {
    return workorder_1.stringToWorkCategory;
  }
});

var usage_points_1 = require("./usage_points");

Object.defineProperty(exports, "UsagePoints", {
  enumerable: true,
  get: function get() {
    return usage_points_1.UsagePoints;
  }
});

var usage_point_1 = require("./usage_point");

Object.defineProperty(exports, "UsagePoint", {
  enumerable: true,
  get: function get() {
    return usage_point_1.UsagePoint;
  }
});

var graph_1 = require("./graph");

Object.defineProperty(exports, "GraphNode", {
  enumerable: true,
  get: function get() {
    return graph_1.GraphNode;
  }
});
Object.defineProperty(exports, "NewNode", {
  enumerable: true,
  get: function get() {
    return graph_1.NewNode;
  }
});
Object.defineProperty(exports, "Relationship", {
  enumerable: true,
  get: function get() {
    return graph_1.Relationship;
  }
});

var alert_1 = require("./alert");

Object.defineProperty(exports, "Alert", {
  enumerable: true,
  get: function get() {
    return alert_1.Alert;
  }
});

var alerts_1 = require("./alerts");

Object.defineProperty(exports, "Alerts", {
  enumerable: true,
  get: function get() {
    return alerts_1.Alerts;
  }
});

var alarm_1 = require("./alarm");

Object.defineProperty(exports, "Alarm", {
  enumerable: true,
  get: function get() {
    return alarm_1.Alarm;
  }
});
Object.defineProperty(exports, "getAlarms", {
  enumerable: true,
  get: function get() {
    return alarm_1.getAlarms;
  }
});

var file_1 = require("./file");

Object.defineProperty(exports, "File", {
  enumerable: true,
  get: function get() {
    return file_1.File;
  }
});
Object.defineProperty(exports, "getFiles", {
  enumerable: true,
  get: function get() {
    return file_1.getFiles;
  }
});

var location_1 = require("./location");

Object.defineProperty(exports, "UnitLocation", {
  enumerable: true,
  get: function get() {
    return location_1.UnitLocation;
  }
});

var meter_1 = require("./meter");

Object.defineProperty(exports, "Meter", {
  enumerable: true,
  get: function get() {
    return meter_1.Meter;
  }
});

var metadata_1 = require("./metadata");

Object.defineProperty(exports, "Metadatum", {
  enumerable: true,
  get: function get() {
    return metadata_1.Metadatum;
  }
});
Object.defineProperty(exports, "getAllMetadata", {
  enumerable: true,
  get: function get() {
    return metadata_1.getAllMetadata;
  }
});

var model_1 = require("./model");

Object.defineProperty(exports, "Model", {
  enumerable: true,
  get: function get() {
    return model_1.Model;
  }
});
Object.defineProperty(exports, "Medium", {
  enumerable: true,
  get: function get() {
    return model_1.Medium;
  }
});

var modem_1 = require("./modem");

Object.defineProperty(exports, "Modem", {
  enumerable: true,
  get: function get() {
    return modem_1.Modem;
  }
});

var identifier_1 = require("./identifier");

Object.defineProperty(exports, "Identifier", {
  enumerable: true,
  get: function get() {
    return identifier_1.Identifier;
  }
});

var status_1 = require("./status");

Object.defineProperty(exports, "Status", {
  enumerable: true,
  get: function get() {
    return status_1.Status;
  }
});
Object.defineProperty(exports, "LifeCycleState", {
  enumerable: true,
  get: function get() {
    return status_1.LifeCycleState;
  }
});
Object.defineProperty(exports, "StatusState", {
  enumerable: true,
  get: function get() {
    return status_1.StatusState;
  }
});

var event_1 = require("./event");

Object.defineProperty(exports, "Entry", {
  enumerable: true,
  get: function get() {
    return event_1.Entry;
  }
});

var profile_1 = require("./profile");

Object.defineProperty(exports, "Profile", {
  enumerable: true,
  get: function get() {
    return profile_1.Profile;
  }
});
Object.defineProperty(exports, "decodeProfile", {
  enumerable: true,
  get: function get() {
    return profile_1.decodeProfile;
  }
});
Object.defineProperty(exports, "ReadingEntry", {
  enumerable: true,
  get: function get() {
    return profile_1.ReadingEntry;
  }
});
Object.defineProperty(exports, "getProfiles", {
  enumerable: true,
  get: function get() {
    return profile_1.getProfiles;
  }
});

var virtual_port_1 = require("./virtual_port");

Object.defineProperty(exports, "VirtualPort", {
  enumerable: true,
  get: function get() {
    return virtual_port_1.VirtualPort;
  }
});

var uri_1 = require("./lwm2m/uri");

Object.defineProperty(exports, "Lwm2mURI", {
  enumerable: true,
  get: function get() {
    return uri_1.Lwm2mURI;
  }
});

var user_1 = require("./user");

Object.defineProperty(exports, "User", {
  enumerable: true,
  get: function get() {
    return user_1.User;
  }
});
Object.defineProperty(exports, "EmptyUser", {
  enumerable: true,
  get: function get() {
    return user_1.EmptyUser;
  }
});
Object.defineProperty(exports, "getCurrentUser", {
  enumerable: true,
  get: function get() {
    return user_1.getCurrentUser;
  }
});
Object.defineProperty(exports, "UserMetadata", {
  enumerable: true,
  get: function get() {
    return user_1.UserMetadata;
  }
});
Object.defineProperty(exports, "MessagingChannelType", {
  enumerable: true,
  get: function get() {
    return user_1.MessagingChannelType;
  }
});